import { render, staticRenderFns } from "./BlackMicropoint.vue?vue&type=template&id=e521a414&scoped=true"
import script from "./BlackMicropoint.vue?vue&type=script&lang=js"
export * from "./BlackMicropoint.vue?vue&type=script&lang=js"
import style0 from "./BlackMicropoint.vue?vue&type=style&index=0&id=e521a414&prod&scoped=true&lang=scss"
import style1 from "./BlackMicropoint.vue?vue&type=style&index=1&id=e521a414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e521a414",
  null
  
)

export default component.exports